// document.addEventListener("click", function (e) {
//   const step1 = e.target.closest(".year-end-banner .step-1");

//   /** ① 点击第一张 → 切换到第二张 */
//   if (step1) {
//     console.log("点击第一张图");
//     const banner = step1.closest(".year-end-banner");
//     if (!banner) return;

//     banner.querySelector(".step-1")?.classList.remove("is-active");
//     banner.querySelector(".step-2")?.classList.add("is-active");
//     return; // ⛔ 防止继续往下执行
//   }

//   /** ② 复制 code（只在 step-2 内生效） */
//   const copyBtn = e.target.closest(".code-copy-btn");
//   if (copyBtn) {
//     const banner = copyBtn.closest(".year-end-banner");
//     if (!banner) return;

//     const code = banner.querySelector(".code-text")?.textContent.trim() || "";

//     if (!code) return;

//     navigator.clipboard
//       .writeText(code)
//       .then(() => {
//         window.utils?.showCopyTip("Copied!", { type: "success" });
//       })
//       .catch(() => {
//         window.utils?.showCopyTip("Copy failed", { type: "error" });
//       });
//   }
// });

document.addEventListener("click", function (e) {
  const step1 = e.target.closest(".year-end-banner .step-1");

  /** ① 点击第一张 → 切换到第二张 */
  // if (step1) {
  //   console.log("点击第一张图");
  //   const banner = step1.closest(".year-end-banner");
  //   if (!banner) return;

  //   banner.querySelector(".step-1")?.classList.remove("is-active");
  //   banner.querySelector(".step-2")?.classList.add("is-active");

  //   // 🔥 保留原有 select_promotion 点击事件
  //   window.pushBannerEvent(banner, "select_promotion", "click_step1");

  //   return; // ⛔ 防止继续往下执行
  // }

  /** ② 复制 code（只在 step-2 内生效） */
  const copyBtn = e.target.closest(".code-copy-btn");
  if (copyBtn) {
    const banner = copyBtn.closest(".year-end-banner");
    if (!banner) return;

    const code = banner.querySelector(".code-text")?.textContent.trim() || "";
    if (!code) return;

    navigator.clipboard
      .writeText(code)
      .then(() => {
        window.utils?.showCopyTip("Copied!", { type: "success" });

        // 🔥 保留原有 select_promotion 点击事件
        window.pushBannerEvent(banner, "select_promotion", "click_copy");

        // 🔥 新增 activity_icon 点击事件
        const routeName = window.utils?.getRouteName?.() || "otherPage";
        gtag("event", "activity_icon", {
          send_to: "G-F0NKM0YQCD",
          event_action: "click",
          event_category: routeName,
          event_label: `${routeName}_Banner::CopyCode`,
        });
      })
      .catch(() => {
        window.utils?.showCopyTip("Copy failed", { type: "error" });
      });
  }

  /** ③ use now 按钮 */
  const useNowBtn = e.target.closest(".js-receive-coupon");
  if (useNowBtn) {
    const banner = useNowBtn.closest(".year-end-banner");
    if (!banner) return;

    // 🔥 保留原有逻辑，例如：
    // markReceived();
    // closePopup();
    // showFloatingButton();

    // 🔥 新增 activity_icon 点击事件
    const routeName = window.utils?.getRouteName?.() || "otherPage";
    gtag("event", "activity_icon", {
      send_to: "G-F0NKM0YQCD",
      event_action: "click",
      event_category: routeName,
      event_label: `${routeName}_Banner::UseNow`,
    });
  }
});

/** 🔥 曝光事件埋点（view_promotion） */
function bannerExposure() {
  console.log("活动页曝光进入");
  document.querySelectorAll(".year-end-banner").forEach((banner) => {
    if (banner.dataset.hasExposed) return; // 防止重复曝光

    banner.dataset.hasExposed = "true";

    window.pushBannerEvent(banner, "view_promotion", "view_banner");
  });
}
// 🔥 页面 DOM 加载后立即触发曝光
document.addEventListener("DOMContentLoaded", bannerExposure);
// /**
//  * gtag 公共方法
//  * @param {HTMLElement} banner - banner DOM
//  * @param {string} eventName - 'view_promotion' | 'select_promotion'
//  * @param {string} event_action - 自定义 action 标识
//  */
// function pushBannerEvent(banner, eventName, event_action) {
//   console.log("进入曝光01");
//   if (typeof gtag !== "function" || !banner) return;
//   console.log("进入曝光02");
//   const img = banner.querySelector(".is-active img");
//   console.log("进入曝光03", img);
//   const routeName = window.utils?.getRouteName?.() || "otherPage";
//   // promotion
//   const promotion_id = `${routeName}_promotion-banner`;
//   const promotion_name =
//     img?.getAttribute("alt") || document.title || "promotion-banner";

//   // creative
//   const creative_name = img?.getAttribute("src")
//     ? img.getAttribute("src").split("/").pop()
//     : "";

//   const creative_slot = banner.querySelector(".is-active").dataset.slot || "1";
//   const item_name =
//     img?.getAttribute("alt") || document.title || "promotion-banner";
//   const item_id = `${routeName}_promotion-banner`;
//   console.log("获取到的内容", creative_slot, item_name);

//   console.log(
//     "banner曝光",
//     eventName,
//     routeName,
//     item_id,
//     promotion_id,
//     promotion_name,
//     creative_name,
//     creative_slot
//   );
//   gtag("event", eventName, {
//     items: [
//       {
//         item_name,
//         item_id,
//         promotion_id,
//         promotion_name,
//         creative_name,
//         creative_slot,
//       },
//     ],
//     send_to: "G-F0NKM0YQCD",
//     event_category: routeName,
//     event_action,
//     event_label: `${eventName}::${promotion_name}`,
//   });
// }

// // 🔥 页面 DOM 加载后立即触发曝光
// document.addEventListener("DOMContentLoaded", bannerExposure);
